export const CURRENT_URL = `${window.location.protocol}//${window.location.host}`;
export const API_URL = `${CURRENT_URL}/wp-json/tmt-insurance/v1`;

const eventUrl = `${API_URL}/event`;

const checkinUrl = `${eventUrl}/checkin`;
const getUncheckedParticipantsLogsUrl = `${eventUrl}/unchecked`;

export const checkin = async (userId, eventId, key, code) => {
  const response = await fetch(checkinUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-WP-Nonce": tmtUser.nonce,
    },
    body: JSON.stringify({
      user: userId,
      event: eventId,
      key: key,
      code: code,
    }),
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();
  return json;
};

export const getUncheckedParticipantsLogs = async () => {
  const response = await fetch(getUncheckedParticipantsLogsUrl);

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const json = await response.json();
  return json;
};
